var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_67_20676)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.217 9.14291L13.4932 5.87433C13.6367 5.73086 13.7173 5.53628 13.7173 5.33338C13.7173 5.13049 13.6367 4.9359 13.4932 4.79243C13.3497 4.64896 13.1552 4.56836 12.9523 4.56836C12.7494 4.56836 12.5548 4.64896 12.4113 4.79243L9.14274 8.06862L5.87417 4.79243C5.7307 4.64896 5.53611 4.56836 5.33322 4.56836C5.13032 4.56836 4.93573 4.64896 4.79226 4.79243C4.6488 4.9359 4.56819 5.13049 4.56819 5.33338C4.56819 5.53628 4.6488 5.73086 4.79226 5.87433L8.06846 9.14291L4.79226 12.4115C4.72085 12.4823 4.66417 12.5666 4.62549 12.6594C4.58681 12.7523 4.56689 12.8518 4.56689 12.9524C4.56689 13.053 4.58681 13.1526 4.62549 13.2454C4.66417 13.3383 4.72085 13.4226 4.79226 13.4934C4.86309 13.5648 4.94736 13.6215 5.04021 13.6602C5.13305 13.6988 5.23264 13.7188 5.33322 13.7188C5.4338 13.7188 5.53338 13.6988 5.62623 13.6602C5.71907 13.6215 5.80334 13.5648 5.87417 13.4934L9.14274 10.2172L12.4113 13.4934C12.4821 13.5648 12.5664 13.6215 12.6593 13.6602C12.7521 13.6988 12.8517 13.7188 12.9523 13.7188C13.0528 13.7188 13.1524 13.6988 13.2453 13.6602C13.3381 13.6215 13.4224 13.5648 13.4932 13.4934C13.5646 13.4226 13.6213 13.3383 13.66 13.2454C13.6987 13.1526 13.7186 13.053 13.7186 12.9524C13.7186 12.8518 13.6987 12.7523 13.66 12.6594C13.6213 12.5666 13.5646 12.4823 13.4932 12.4115L10.217 9.14291Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_67_20676"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.2857,
    height: 18.2857,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseOutline);
export default __webpack_public_path__ + "static/media/close-outline.5cfad2d48da68d9f71bf8e0bae600b18.svg";
export { ForwardRef as ReactComponent };